import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/**
 * One resolved TileSet per distinct `tile_set` among a flat sort's y-sorted
 * TileMapLayer items. A tile row's sort key comes from its own grid's pitch, and
 * `TileGroupRenderer` draws each row from its own model, so the sorter must agree.
 */
import { useMemo } from 'react';
import { useTileSetModel } from './useTileSetModel.js';
const NO_MODELS = new Map();
/** Every distinct `tile_set` the tileGroup items name, in first-seen order. */
export function tileSetRefsOf(items) {
    const refs = new Set();
    for (const item of items) {
        if (item.kind === 'tileGroup' && item.tileData?.tileSetRef)
            refs.add(item.tileData.tileSetRef);
    }
    return [...refs];
}
/**
 * Resolve `refs` and hand the loaded models to `children`, keyed by ref. A ref
 * missing from the map has not arrived, and the caller leaves that layer unexpanded.
 * Recursive, one `useTileSetModel` per level, so each instance keeps a fixed hook order.
 */
export function TileSetModels({ refs, resolved = NO_MODELS, children, }) {
    const head = refs[0];
    const { model, status } = useTileSetModel(head);
    const next = useMemo(() => {
        if (!head || status !== 'loaded' || !model)
            return resolved;
        const merged = new Map(resolved);
        merged.set(head, model);
        return merged;
    }, [head, model, status, resolved]);
    const rest = useMemo(() => refs.slice(1), [refs]);
    if (rest.length === 0)
        return _jsx(_Fragment, { children: children(next) });
    return (_jsx(TileSetModels, { refs: rest, resolved: next, children: children }));
}
//# sourceMappingURL=ySortTileSetModels.js.map